import { ILegacyCartEntry } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

import { CartEntryType } from './types';

export const isCartEntryItem = (cartEntry: ILegacyCartEntry) =>
  cartEntry.type === CartEntryType.item;

export const isCartEntryCombo = (cartEntry: ILegacyCartEntry) =>
  cartEntry.type === CartEntryType.combo;

export const isCartEntryItemOption = (cartEntry: ILegacyCartEntry) =>
  cartEntry.type === CartEntryType.itemOption;

export const isCartEntryComboSlot = (cartEntry: ILegacyCartEntry) =>
  cartEntry.type === CartEntryType.comboSlot;

export const isCartEntryPicker = (pathname: string) =>
  new RegExp(`^${routes.menu}/picker`).test(pathname);
